import { api } from "@api/api";
import { Game } from "@api/public/get/getGames";

const deleteGame = async (gameID: string) => {
  const { data } = await api.post<Game>("/deleteGame", { gameID });
  return data;
};

export default deleteGame;
